export const events = {
  USER_SIGNED_IN: 'auth/user-signed-in',
  USER_SIGNED_OUT: 'auth/user-signed-out',
};